import { IErrorLoggerWithUserSupport } from '@verv-inc/js-toolkit/core-logs/lib/ErrorLoggerWithUserSupport';
import {
	ComposeSentryErrorLogger,
	Environment,
} from '@verv-inc/js-toolkit/core-logs/src/sentryErrorLogger';
import packageJson from '../../../package.json';

const sentryKey =
  'https://dcedb7e4a6b043218814b97b7c4c9684@o1355523.ingest.sentry.io/6702148';
export function ComposeVervSentryErrorLogger(): IErrorLoggerWithUserSupport {
	let enviroment: Environment = Environment.prod;
	if (process.env.ENVIRONMENT === 'dev') {
		enviroment = Environment.dev;
	} else if (process.env.ENVIRONMENT === 'test') {
		enviroment = Environment.test;
	}
	const appVersion: string = packageJson.version;

	return ComposeSentryErrorLogger(sentryKey, enviroment, appVersion);
}

const errorLogger: IErrorLoggerWithUserSupport = ComposeVervSentryErrorLogger();
export default errorLogger;
